import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import { StateRoot } from "@/store/state";
import { getLoginData } from "@/lib/authHelper";

export function authoritiesRouteGuard(requiredAuthorities: StateRoot["authorities"]): boolean {
  const data = getLoginData();
  return checkAuthorities(data?.authorities ?? [], requiredAuthorities);
}
